<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Selecciona el plan de estudios y el periodo.
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="mb-md-0 mb-2"
        >
          <label>Plan de Estudios</label>
          <v-select
            v-model="selectedPlan"
            :options="planes"
            :get-option-label="plan => plan.nombre"
            placeholder="Selecciona"
            class="w-100 text-sm"
          >
            <span slot="no-options">No hay planes de estudio</span>
          </v-select>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    planes: {
      type: Array,
      default() {
        return []
      },
    },
    periodos: {
      type: Array,
      default() {
        return []
      },
    },
    nivel: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      selectedPlan: null,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
